import React from 'react';
import Navigation from './Navigation';
import Alerts from './Alerts';
import Notifications from './Notifications';
import { ContentErrorBoundary } from '@views/ErrorBoundary';
import ContextMenu from '@components/Menus/ContextMenu';
import KeyboardShortcuts from '@views/KeyboardShortcuts';
import ModalController from '@views/ModalController';
import Updates from '@views/Updates';
import WelcomeGuide from '@views/WelcomeGuide';
import { Outlet } from 'react-router-dom';
import styles from './PrimaryLayout.module.scss';
import UserCallouts from '@views/UserCallouts/UserCallouts';
import { AuthContext, WorkspaceContext } from '@repo/utils/context';
import ActivitySSEController from '@views/ActivitySSEController';
import UdoMenu from '@components/Header/UdoMenu';

export function SettingsLayout() {
  return (
    <AuthContext.Consumer>
      {() => (
        <WorkspaceContext.Consumer>
          {() => (
            <>
              <Alerts />
              {/* Wrap with error boundary? */}
              <Outlet />
              <ModalController />
              <WelcomeGuide />
            </>
          )}
        </WorkspaceContext.Consumer>
      )}
    </AuthContext.Consumer>
  );
}

export default function PrimaryLayout({ renderUserCallouts }: { renderUserCallouts?: boolean }) {
  return (
    <AuthContext.Consumer>
      {() => (
        <WorkspaceContext.Consumer>
          {() => (
            <>
              <Alerts />
              <Notifications />
              <div className={styles.container}>
                <Navigation />
                <ContentErrorBoundary>
                  <Outlet />
                </ContentErrorBoundary>
                <UdoMenu />
              </div>
              <KeyboardShortcuts />
              <ModalController />
              <ActivitySSEController />
              <Updates />
              <WelcomeGuide />
              <ContextMenu />
              {renderUserCallouts && <UserCallouts />}
            </>
          )}
        </WorkspaceContext.Consumer>
      )}
    </AuthContext.Consumer>
  );
}
